module.exports = __webpack_public_path__ + "static/media/part.8d47bc6f.svg";